import { render, staticRenderFns } from "./ConfiguracaoGeralParametros.vue?vue&type=template&id=f38bc514&scoped=true"
import script from "./ConfiguracaoGeralParametros.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoGeralParametros.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoGeralParametros.vue?vue&type=style&index=0&id=f38bc514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38bc514",
  null
  
)

export default component.exports